module.exports = __webpack_public_path__ + "static/img/img002.e3bce01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img002.png
// module id = SgpO
// module chunks = 1